import { useMemo } from 'react';
import { useCategory } from '../api/hooks/catalog';
import { RoleType } from '../authentication/hooks/user';
import { useCatalogueService } from '../catalogue/useCatalogueService';
import {
  usePoSelectedFinanceModels,
  usePoSelectedPeripheralFinanceModel
} from '../purchaseOrders/usePurchaseOrderService';

export const useSelectedPurchaseOrderFinanceModelForCategoryAndManufacturer = (
  categoryId: string,
  manufacturerId: string
) => {
  const [category] = useCategory(categoryId);

  if (!category) throw new Error(`Missing category with id ${categoryId}`);

  const [configuration] = useCatalogueService(state => [state.configuration]);

  const purchaseOrderSelectedModels = usePoSelectedFinanceModels();
  const purchaseOrderSelectedPeripheralModel = usePoSelectedPeripheralFinanceModel();

  return useMemo(() => {
    if (configuration.for !== RoleType.Company) return null;

    if (category.isMainDevice) {
      const selectedModel =
        purchaseOrderSelectedModels?.find(
          model => model.manufacturerId === manufacturerId && model.categoryId === categoryId
        ) ?? null;

      return selectedModel;
    } else {
      const selectedModel = purchaseOrderSelectedPeripheralModel ?? null;
      return selectedModel;
    }
  }, [purchaseOrderSelectedModels, purchaseOrderSelectedPeripheralModel, categoryId, manufacturerId]);
};
